import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useCariAtamaBildirim } from '../../hooks/useCariAtamaBildirim';
import { useTabActions } from '../../contexts/tab-navigation';
import { setCariListLaunch } from '../../utils/cariListLaunch';
import { resetCarilistCache } from '../../pages/CARI/carilist';
import routes from '../../app-routes';
import * as glb from '../../globals';
import Dict from '../../messages';
import './cari-atama-bildirim-badge.scss';

function findCariRoute() {
  const screens = Array.isArray(glb.default.EKRANLkp) ? glb.default.EKRANLkp : [];
  const cariScreen = screens.find((x) => String(x.EKR_EKRANADI || '').toLowerCase() === 'cari');
  const navPath = cariScreen ? `/${cariScreen.EKR_EKRANADI}` : '/CARI';
  return routes.find((r) => String(r.path || '').toUpperCase() === navPath.toUpperCase())
    || routes.find((r) => String(r.path || '').toLowerCase() === '/cari');
}

function HeartBadge({ color, count, title, label, onClick }) {
  return (
    <button
      type="button"
      className={`cari-atama-heart cari-atama-heart--${color}`}
      title={title}
      onClick={onClick}
      aria-label={title}
    >
      <span className="cari-atama-heart__icon" aria-hidden>♥</span>
      <span className="header-notification-label">{label}</span>
      <span className="cari-atama-heart__count">{count}</span>
    </button>
  );
}

export default function CariAtamaBildirimBadge() {
  const { ozet } = useCariAtamaBildirim();
  const { openTab } = useTabActions();
  const history = useHistory();

  const openCariList = useCallback((launch) => {
    const route = findCariRoute();
    if (!route?.component) return;

    resetCarilistCache();
    setCariListLaunch(launch);

    const screens = Array.isArray(glb.default.EKRANLkp) ? glb.default.EKRANLkp : [];
    const cariScreen = screens.find((x) => String(x.EKR_EKRANADI || '').toLowerCase() === 'cari');
    const title = Dict.get(cariScreen?.EKR_ETIKET) || Dict.get('Cari') || 'Cari';

    openTab(route.path, title, route.component);
    try {
      if (history.location?.pathname !== '/home') {
        history.push('/home');
      }
    } catch (_) { /* ignore */ }
  }, [openTab, history]);

  const onYeniAtamaClick = useCallback(() => {
    openCariList({ mode: 'yeniAtama' });
  }, [openCariList]);

  const onAtamaBosClick = useCallback(() => {
    if (!ozet.admin_mi) return;
    openCariList({ mode: 'atamaBos' });
  }, [openCariList, ozet.admin_mi]);

  const yeni = Number(ozet.yeni_atama_sayisi) || 0;
  const bos = Number(ozet.atama_bos_sayisi) || 0;

  return (
    <div className="cari-atama-bildirim-wrap" role="group" aria-label="Cari atama bildirimleri">
      <HeartBadge
        color="red"
        count={yeni}
        label={Dict.get('Atama')}
        title={yeni === 1
          ? 'Yeni atama bildirimi: Size atanan 1 cari (son 24 saat)'
          : `Yeni atama bildirimi: Size atanan ${yeni} cari (son 24 saat)`}
        onClick={onYeniAtamaClick}
      />
      {ozet.admin_mi && (
        <HeartBadge
          color="blue"
          count={bos}
          label={Dict.get('Atamasız')}
          title={bos === 1
            ? 'Atamasız cari bildirimi: 1 cari (son 24 saat)'
            : `Atamasız cari bildirimi: ${bos} cari (son 24 saat)`}
          onClick={onAtamaBosClick}
        />
      )}
    </div>
  );
}
